module.exports = __webpack_public_path__ + "img/top_button_3.99259408.png";